import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSummary(agro_exporter_id) {
    return RequesterV1.get(
      `dashboard/agro_exporter/container_export/${agro_exporter_id}/fetch_summary`
    );
  },
}
